<template>
  <div>
    <lerner-header :show-login-form="false" :pending="pending"></lerner-header>
    <page-header title="Request Pricing"></page-header>
    <RequestPricingForm v-on:submit="submitRequest" :pending="pending"/>
    <app-footer :pages="pages"></app-footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import AppFooter from '@/component/AppFooter';
  import LernerHeader from '@/component/Header';
  import RequestPricingForm from './RequestPricingForm';
  import ContactService from '@/common/services/contact.service';
  import PageHeader from '@/component/PageHeader';
  import { CHANGE_DOC_TITLE, SHOW_NOTIFICATION } from '@/store/actions/app.actions';

  export default {
    name: 'RequestPricing',

    components: {
      PageHeader,
      LernerHeader,
      RequestPricingForm,
      AppFooter
    },

    computed: {
      ...mapGetters([
        'pages'
      ])
    },

    data: () => {
      return {
        pending: false
      }
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: 'Request Pricing', useBaseTitle: true})
    },

    methods: {
      submitRequest(requestData) {
        this.pending = true;

        return ContactService.requestPricing(requestData)
          .then(() => this.$router.push({name: 'pricing-acknowledge'}))
          .catch(e => this.$store.dispatch(SHOW_NOTIFICATION, {type: 'error', message: e}))
          .finally(() => this.pending = false);
      }
    }
  };
</script>
